import React, { useMemo, useState } from "react";
import { Text, View } from "react-native";
import RsvpPrimaryButton from "./RsvpPrimaryButton";
import RsvpTextField from "./RsvpTextField";

interface Props {
  onSubmit: (playerId: string) => void;
  submitting?: boolean;
}

const PlayerIdForm: React.FC<Props> = ({ onSubmit, submitting }) => {
  const [playerId, setPlayerId] = useState("");
  const [confirmPlayerId, setConfirmPlayerId] = useState("");

  const trimmedPlayerId = playerId.trim();
  const trimmedConfirm = confirmPlayerId.trim();

  const mismatch = useMemo(
    () => trimmedConfirm.length > 0 && trimmedPlayerId !== trimmedConfirm,
    [trimmedPlayerId, trimmedConfirm],
  );

  const canSubmit =
    trimmedPlayerId.length > 0 && trimmedPlayerId === trimmedConfirm;

  const handleSubmit = () => {
    if (!canSubmit) return;
    onSubmit(trimmedPlayerId);
  };

  return (
    <View style={{ gap: 16 }}>
      <RsvpTextField
        label="Player ID"
        value={playerId}
        onChangeText={setPlayerId}
        autoCapitalize="none"
        autoCorrect={false}
        testID="player-id"
      />
      <View style={{ gap: 6 }}>
        <RsvpTextField
          label="Re-enter Player ID"
          value={confirmPlayerId}
          onChangeText={setConfirmPlayerId}
          autoCapitalize="none"
          autoCorrect={false}
          error={mismatch}
          testID="confirm-player-id"
          returnKeyType="go"
          onSubmitEditing={handleSubmit}
        />
        {mismatch ? (
          <Text style={{ color: "#f87171", fontSize: 13 }}>
            Player IDs don't match.
          </Text>
        ) : null}
      </View>
      <RsvpPrimaryButton
        title="Continue"
        disabled={!canSubmit}
        loading={submitting}
        onPress={handleSubmit}
        testID="continue"
        style={{ marginTop: 8 }}
      />
    </View>
  );
};

export default PlayerIdForm;
